import React, { useEffect, useState } from "react";
import {
  fetchOrderProblems,
  reporterLabel,
} from "../../../views/Delivery/orderProblemsApi";
import WidgetFrame, { WidgetEmpty } from "./WidgetFrame";

// Open order problems at a glance (dashboard is Admin/Executive-gated, and
// so is this widget via the catalog roles).
const OrderProblemsWidget = () => {
  const [problems, setProblems] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    fetchOrderProblems()
      .then((list) => setProblems(Array.isArray(list) ? list : []))
      .catch(() => setFailed(true));
  }, []);

  if (failed) {
    return (
      <WidgetFrame title="Order Problems" to="/order-problems">
        <WidgetEmpty>Couldn't load order problems.</WidgetEmpty>
      </WidgetFrame>
    );
  }

  if (problems === null) {
    return (
      <WidgetFrame title="Order Problems" to="/order-problems">
        <WidgetEmpty>Loading order problems…</WidgetEmpty>
      </WidgetFrame>
    );
  }

  const open = problems.filter((p) => p.status !== "resolved");
  const recent = open.slice(0, 3);

  return (
    <WidgetFrame title="Order Problems" to="/order-problems">
      <p className="flex items-baseline gap-1.5 text-sm">
        <span className="text-2xl font-semibold tabular-nums tracking-tight">{open.length}</span>{" "}
        <span className="app-muted">open</span>
      </p>
      {recent.length > 0 ? (
        <ul className="mt-2.5 space-y-1.5">
          {recent.map((p) => (
            <li key={p._id} className="truncate text-sm">
              <span className="font-medium">{p.orderNumber || "No order #"}</span>
              <span className="app-muted"> — {reporterLabel(p)}</span>
            </li>
          ))}
        </ul>
      ) : (
        <WidgetEmpty>Nothing open right now.</WidgetEmpty>
      )}
    </WidgetFrame>
  );
};

export default OrderProblemsWidget;
